import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../environment/environment';
import { Constants } from '../../common/helper/Constants';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.auth.authority,
    redirectUrl: environment.auth.redirect_uri,
    postLogoutRedirectUri: environment.auth.post_logout_redirect_uri,
    unauthorizedRoute: '/' + Constants.routes.forbiddenPath,
    forbiddenRoute: '/' + Constants.routes.forbiddenPath,
    clientId: environment.auth.clientId,
    scope: environment.auth.scope,
    responseType: 'code',
    ignoreNonceAfterRefresh: true,
    allowUnsafeReuseRefreshToken: false,
    disableRefreshIdTokenAuthTimeValidation: true,
    silentRenew: true,
    useRefreshToken: true,
    autoUserInfo: true,
    renewTimeBeforeTokenExpiresInSeconds: 30,
    renewUserInfoAfterTokenRenew: true,
    triggerAuthorizationResultEvent: true,
    secureRoutes: [
      'http://localhost:5084/',
      'https://localhost:7094/',
      'https://gate-app-api-dev.azurewebsites.net/',
      'https://gate-dev.acp-gruppe.com/',
      'https://gate-dev-api.acp-gruppe.com',
      'https://gate-api.acp-gruppe.com',
      'https://gate-app-api-dev-devstable.azurewebsites.net',
      'https://gate-devstable-api.acp-gruppe.com',
      'https://gate-preprod-api.acp-gruppe.com',
      'https://gate-app-api-prod-preprod-etbxf2hbgdekhygg.germanywestcentral-01.azurewebsites.net'
    ],
    logLevel: environment.production ? LogLevel.Error : LogLevel.Debug,
  },
};
